import api from './api';
import type { Course } from './recommendationService';

/** #517 — AI course recommendations (rule candidates → LLM picks with a reason). */
export interface AiRecommendation {
    id: number;
    course: Course;
    score: number;
    reason: string;
    source: 'builds_on' | 'fills_gap' | 'interest' | 'next_step';
    seen: boolean;
    clicked: boolean;
    enrollmentMode?: string;
    isLicensedReference?: boolean;
}

export interface AiRecommendationsResponse {
    recommendations: AiRecommendation[];
    count: number;
    generatedAt: string | null;
}

export const aiRecommendationService = {
    async list(): Promise<AiRecommendationsResponse> {
        const { data } = await api.get<AiRecommendationsResponse>('/ai/recommendations');
        return data;
    },
    async refresh(force = false): Promise<AiRecommendationsResponse> {
        const { data } = await api.post<AiRecommendationsResponse>(`/ai/recommendations/refresh${force ? '?force=1' : ''}`);
        return data;
    },
    async click(id: number): Promise<void> {
        await api.post(`/ai/recommendations/${id}/click`);
    },
};

export default aiRecommendationService;
